export default __webpack_public_path__ + "static/media/aboutUsGalleryDesktop.fcd42c83.jpg";